import React, { useMemo } from "react";
import { Tooltip } from "antd";
import { addPercentages } from "../utils/calculations";

export interface StatusData {
  id: string;
  title: string;
  count: number;
}

interface ApplicationsByStatusChartProps {
  data: StatusData[];
  onDrilldown: (statusId: string, title: string) => void;
}

export const ApplicationsByStatusChart: React.FC<
  ApplicationsByStatusChartProps
> = ({ data, onDrilldown }) => {
  const dataWithPercentages = useMemo(() => {
    return addPercentages(data, "count");
  }, [data]);

  // Sort: count desc, then alpha
  const sortedData = useMemo(() => {
    return [...dataWithPercentages].sort((a, b) => {
      // Sort by count descending
      if (a.count !== b.count) {
        return b.count - a.count;
      }

      // Tie-break by alphabetical order
      return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
    });
  }, [dataWithPercentages]);

  const maxCount = Math.max(...sortedData.map((d) => d.count));

  return (
    <div
      className="bar-chart"
      style={{ maxHeight: "325px", overflowY: "auto" }}
    >
      {sortedData.map((item, idx) => (
        <Tooltip key={idx} title={item.title} placement="topLeft">
          <div
            className="bar-chart-row"
            onClick={() => onDrilldown(item.id || item.title, item.title)}
          >
            <div className="bar-label">{item.title}</div>
            <div className="bar-container">
              <div
                className="bar-fill"
                style={{ width: `${(item.count / maxCount) * 100}%` }}
              />
            </div>
            <div className="bar-value">
              {item.count} ({item.percentage}%)
            </div>
          </div>
        </Tooltip>
      ))}
    </div>
  );
};
